@use '../functions/color' as color-functions;
@use '../functions/string';
@use '../variables/color';

// stylelint-disable selector-pseudo-class-no-unknown, property-no-unknown -- :export is the CSS modules syntax
:export {
  @each $name, $value in color.$color-map {
    #{string.camel-case('color-#{$name}')}: #{color-functions.to-hex($value)};
  }

  @each $name, $value in color.$role-map {
    #{string.camel-case($name)}: #{color-functions.to-hex($value)};
  }
}
